import Highway from "@dogstudio/highway";
import { splitText } from "./split.js";
import { makeSpline } from "./spline.js";
import { gsap } from "gsap/all";
import { createAccordion } from "./accordion.js";

import { changeColor, sudopAnimations } from "./gsapAnim";

class SudopPageTransition extends Highway.Transition {
  /************************************ FROM  ***************************** */

  out({ from, trigger, done }) {
    let curtain = document.getElementById("pageTransitionCurtain");

    new gsap.timeline({
      onComplete: () => {
        const topNav = document.getElementById("header");
        topNav.classList.remove("isHide");
        done();
      },
    }).fromTo(
      curtain,
      1.2,
      { height: 0 },
      { height: "100%", ease: "power4.out" }
    );
  }

  /************************************ TO ***************************** */

  in({ from, to, trigger, done }) {
    let curtain = document.getElementById("pageTransitionCurtain");
    const heroImg = document.getElementById("heroImage");
    var ease = "power4.inOut";
    let nav = document.querySelector("nav");
    const topNav = document.getElementById("header");
    const perex = document.querySelectorAll("[perex]");
    const animToo = document.querySelectorAll("[animToo]");

    //remove previous content
    from.remove();
    makeSpline(to.dataset.routerView);
    //
    createAccordion(to.dataset.routerView);
    splitText();

    //chech topNav status
    topNav.classList.remove("hidden");

    //scroll page to top
    window.scrollTo(0, 0);
    // makeSpline();
    //call animation
    sudopAnimations(to.dataset.routerView);
    changeColor(to.dataset.routerView);

    //solve menu links
    const links = document.querySelectorAll("nav a");

    for (let i = 0; i < links.length; i++) {
      const link = links[i];

      link.classList.remove("is-active");

      if (link.href === location.href) {
        link.classList.add("is-active");
      }
    }
    topNav.classList.remove("isHide");
    //And play enter animation
    new gsap.timeline({
      defaults: { ease: ease, duration: 1.8 },
      onStart: () => {},
      onComplete: () => {
        done();
      },
    })
      .fromTo(
        curtain,
        1.2,
        { height: "100%" },
        { height: 0, ease: "power4.out" }
      )

      .fromTo(
        headline,

        { opacity: 0, y: window.innerHeight / 10, filter: "blur(5px)" },
        { opacity: 1, y: 0, filter: "blur(0px)", ease: "power4.inOut" },
        "<"
      )
      .fromTo(
        heroImg,

        { scale: 1.1 },
        { scale: 1, ease: "power4.inOut" },
        "<10%"
      )

      .fromTo(
        perex,

        { opacity: 0, y: window.innerHeight / 10, filter: "blur(5px)" },
        { opacity: 1, y: 0, filter: "blur(0px)", ease: "power4.inOut" },
        "<10%"
      )
      .fromTo(
        animToo,

        { opacity: 0, y: window.innerHeight / 10, filter: "blur(5px)" },
        { opacity: 1, y: 0, filter: "blur(0px)", ease: "power4.inOut" },
        "<"
      )
      .fromTo(
        nav,

        { opacity: 0, scale: 0.98 },
        { opacity: 1, scale: 1, ease: "power4.inOut" },
        "<"
      );
  }
}

//

export function setPageTransition() {
  const H = new Highway.Core({
    transitions: {
      default: SudopPageTransition,
    },
  });
}
